export default "__VITE_PUBLIC_ASSET__d9ae1ef2__"